import { render } from "./AdminRegistrations.vue?vue&type=template&id=16f25de3&scoped=true"
import script from "./AdminRegistrations.vue?vue&type=script&lang=js"
export * from "./AdminRegistrations.vue?vue&type=script&lang=js"

import "./AdminRegistrations.vue?vue&type=style&index=0&id=16f25de3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16f25de3"]])

export default __exports__